import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.5852 18.01L5.5752 12L11.5852 5.98999L13.0002 7.40399L8.4002 12.004L13.0002 16.604L11.5862 18.01H11.5852ZM17.0102 18.01L10.9992 12L17.0102 5.98999L18.4242 7.40399L13.8242 12.004L18.4242 16.604L17.0112 18.01H17.0102Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronDuoLeft"
);
